import { jsx as t, jsxs as i } from "react/jsx-runtime";
import "react";
var a = (l) => /* @__PURE__ */ i("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...l,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-990 -276)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V19.9992H20V0Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0.000183105H0V6.66673H20V0.000183105Z",
      fill: "#6DA544"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 13.3334H0V20H20V13.3334Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ t("path", {
      d: "M10 15C12.7614 15 15 12.7614 15 9.99996C15 7.23852 12.7614 4.99994 10 4.99994C7.23858 4.99994 5 7.23852 5 9.99996C5 12.7614 7.23858 15 10 15Z",
      fill: "#0052B4"
    }),
    /* @__PURE__ */ t("path", {
      d: "M9.9998 6.12811L10.9024 8.90598H13.8279L11.4602 10.6229L12.3699 13.409L9.9998 11.684L7.63332 13.4058L8.53934 10.6229L6.17383 8.90598H9.09715L9.9998 6.12811Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ t("path", {
      d: "M13.598 10.6913L10.7346 9.76091L12.5043 7.32527L11.7688 6.79089L9.99914 9.22661L8.22961 6.79093L7.4941 7.32523L9.26371 9.76102L6.40039 10.6913L6.68129 11.556L9.54465 10.6256V13.6363H10.4538V10.6256L13.317 11.556L13.598 10.6913Z",
      fill: "#FFDA44"
    })
  ]
});
export {
  a as default
};
